// Collection Tab Switch
document.querySelectorAll(".pf-ctab-btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    const collectionContainer = btn.closest(".pf-collection-body");
    const activeBtn = collectionContainer.querySelector(
      ".pf-ctab-btn[data-active='true']"
    );

    if (activeBtn === btn) return;

    activeBtn.removeAttribute("data-active");
    btn.setAttribute("data-active", "true");

    const activeTabContent = collectionContainer.querySelector(
      ".pf-products-list[data-active='true']"
    );
    activeTabContent.removeAttribute("data-active");

    const tabContent = collectionContainer.querySelector(
      `.pf-products-list[data-tab='${btn.dataset.tab}']`
    );
    tabContent.setAttribute("data-active", "true");
  });
});

// Mobile Collection Button Menu Toggle
var collectionMenuBtns = document.querySelectorAll(".pf-ctabs-toggle");

collectionMenuBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    collectionTabsList = btn.closest(".pf-collection-tabs");

    collectionTabsList.classList.toggle("pf-active");
  });
});
